import React, { useEffect, useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { Puff } from "react-loading-icons";
import { AuthContext } from "../../../../Context/AppContext";
import "./EventList.css";
import EventFormModal from "../../Events/form/EventFormModal";
import EventListRequests from "./EventListRequests";
import NavBar from "../../../../components/NavBar";
import SpotModal from "../../Nightspots/List/SingleSpot/SpotModal";
import EventsListCards_Card from "./EventsListCards_Card";
import SpotSelectionModal from "./SpotSelectionModal";

const EventListCards = () => {
  const { userInfo } = useContext(AuthContext);
  let params = useParams();
  const [data, setData] = useState({
    events: [],
    venues: [],
    loading: true,
  });

  const [eventModal, setEventModal] = useState({
    show: false,
    id: null,
    venue_type: null
  });

  const [modalCreateSpot, setmodalCreateSpot] = useState(false);
  const handleShowModalCreateSpot = () => setmodalCreateSpot(true);
  const handleHideModalCreateSpot = () => {
    setmodalCreateSpot(false);
    setShowSpotSelection(false);
  };

  const [showSpotSelection, setShowSpotSelection] = useState(false);
  const handleShowSpotSelection = () => setShowSpotSelection(true);
  const handleHideSpotSelection = () => setShowSpotSelection(false);

  const requestEventList = async (filter = "") => {
    setData((prev) => ({ ...prev, loading: true }));
    let requestSize = await EventListRequests.getEventList(params, filter);
    if (requestSize && requestSize.status) {
      setData({
        events: requestSize.data.events,
        venues: requestSize.data.venues,
        loading: false,
      });
    } else {
      setData((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    document.title = "Os meus Eventos | Nightspot";
    requestEventList();
  }, []);

  const InsideLoading = () => {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center py-5">
        <Puff stroke="#6366f1" />
        <span className="mt-3 text-muted">A carregar os teus eventos...</span>
      </div>
    );
  };

  const BtnAddEvent = () => (
    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className="block-cards text-center d-flex flex-column align-items-center justify-content-center h-100 py-5" style={{ borderStyle: 'dashed', borderWidth: '2px', borderColor: 'rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.02)' }}>
        <div className="mb-3">
          <i className="fa-solid fa-circle-plus fs-1 text-primary"></i>
        </div>
        <h4 className="fw-bold text-white">Criar Novo Evento</h4>
        <p className="text-muted small px-4 mb-4">
          Organiza um novo evento e começa a receber reservas e vender bilhetes.
        </p>
        {data.venues.length > 0 ? (
          <button
            className="btn btn-event-action btn-public-link px-4 rounded-pill"
            onClick={handleShowSpotSelection}
          >
            Começar Agora
          </button>
        ) : (
          <button onClick={handleShowModalCreateSpot} className="btn btn-event-action btn-public-link px-4 rounded-pill">
            Criar Spot Primeiro
          </button>
        )}
      </div>
    </div>
  );

  const CardsList = () => {
    if (data.venues.length === 0) return <div className="col-12"><NoResultsVenues /></div>;

    return (
      <div className="row">
        <BtnAddEvent />
        {data.events.length === 0 ? (
          <div className="col-12 col-md-6 col-lg-8">
            <NoResultsEvents />
          </div>
        ) : (
          data.events.map((item, key) => (
            <EventsListCards_Card item={item} key={key} />
          ))
        )}
      </div>
    );
  };

  const NoResultsVenues = () => (
    <div className="box-dashboard text-center py-5">
      <i className="fa-solid fa-location-dot fs-1 text-muted mb-3 d-block"></i>
      <h3 className="text-white">Não tens spots criados</h3>
      <p className="text-muted mb-4">Deverás criar um spot antes de poderes gerir eventos.</p>
      <button onClick={handleShowModalCreateSpot} className="btn btn-event-action btn-public-link px-4 rounded-pill">
        Criar o meu primeiro Spot
      </button>
    </div>
  );

  const NoResultsEvents = () => (
    <div className="box-dashboard text-center py-5 h-100 d-flex flex-column align-items-center justify-content-center">
      <i className="fa-solid fa-calendar-xmark fs-1 text-muted mb-3"></i>
      <h3 className="text-white">Nenhum evento encontrado</h3>
      <p className="text-muted">Começa por criar o teu primeiro evento para o teu spot!</p>
    </div>
  );

  return (
    <NavBar>
      {eventModal.show && eventModal.id && (
        <EventFormModal
          show={eventModal.show}
          id={eventModal.id}
          venue_type={eventModal.venue_type}
          handleModalhide={() => setEventModal({ show: false, id: null, venue_type: null })}
        />
      )}
      <div className="py-4 dashboard-content">
        <div className="row mb-4 align-items-center">
          <div className="col-12 col-md-8">
            <h1 className="events-section-title">Os teus Eventos</h1>
            <p className="events-section-subtitle mb-0">Gere os teus eventos, guestlists e estatísticas em tempo real.</p>
          </div>
          <div className="col-12 col-md-4 d-flex justify-content-md-end mt-3 mt-md-0">
            <button
              onClick={() => requestEventList("closed")}
              className="btn btn-event-action btn-stats px-4 rounded-pill"
            >
              <i className="fa-solid fa-box-archive me-2"></i>
              Arquivo
            </button>
          </div>
        </div>

        {data.loading ? <InsideLoading /> : <CardsList />}

        <SpotSelectionModal
          show={showSpotSelection}
          onHide={handleHideSpotSelection}
          venues={data.venues}
          onSelectSpot={(venue) => {
            setEventModal({ show: true, id: venue.id, venue_type: venue.type });
            handleHideSpotSelection();
          }}
          onCreateSpot={() => {
            handleShowModalCreateSpot();
          }}
        />

        <SpotModal show={modalCreateSpot} handleModalhide={handleHideModalCreateSpot} />
      </div>
    </NavBar>
  );
};

export default EventListCards;
